import { createApiRef, createRouteRef, createPlugin, createApiFactory, identityApiRef, discoveryApiRef, fetchApiRef, createRoutableExtension } from '@backstage/core-plugin-api';

const bulletinBoardApiRef = createApiRef({
  id: "bulletin-board"
});
class BulletinBoardClient {
  constructor(options) {
    this.identityApi = options.identityApi;
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }
  async getBulletins() {
    const baseUrl = await this.discoveryApi.getBaseUrl("bulletin-board");
    return await this.fetchApi.fetch(`${baseUrl}/bulletins`).then((response) => response.json());
  }
  async createBulletin(bulletin) {
    const baseUrl = await this.discoveryApi.getBaseUrl("bulletin-board");
    const user = await (await this.identityApi.getProfileInfo()).displayName;
    bulletin.user = user;
    return await this.fetchApi.fetch(`${baseUrl}/bulletins`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(bulletin)
    }).then((res) => res.json());
  }
  async updateBulletin(id, bulletin) {
    const baseUrl = await this.discoveryApi.getBaseUrl("bulletin-board");
    const user = await (await this.identityApi.getProfileInfo()).displayName;
    bulletin.user = user;
    return await this.fetchApi.fetch(`${baseUrl}/bulletins/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(bulletin)
    }).then((res) => res.json());
  }
  async deleteBulletin(id) {
    const baseUrl = await this.discoveryApi.getBaseUrl("bulletin-board");
    return await this.fetchApi.fetch(`${baseUrl}/bulletins/${id}`, { method: "DELETE" }).then((res) => res.json());
  }
}

const rootRouteRef = createRouteRef({
  id: "bulletin-board"
});

const bulletinBoardPlugin = createPlugin({
  id: "bulletin-board",
  routes: {
    root: rootRouteRef
  },
  apis: [
    createApiFactory({
      api: bulletinBoardApiRef,
      deps: {
        identityApi: identityApiRef,
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef
      },
      factory: ({ identityApi, discoveryApi, fetchApi }) => new BulletinBoardClient({ identityApi, discoveryApi, fetchApi })
    })
  ]
});
const BulletinBoardPage = bulletinBoardPlugin.provide(
  createRoutableExtension({
    name: "BulletinBoardPage",
    component: () => import('./index-14803a43.esm.js').then((m) => m.BulletinBoardPage),
    mountPoint: rootRouteRef
  })
);

export { BulletinBoardPage as B, bulletinBoardPlugin as a, bulletinBoardApiRef as b };
//# sourceMappingURL=index-9838d024.esm.js.map
